import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { LinkProps, useNavigate } from 'react-router-dom';
import { RouterLinkButton } from './RouterLinkButton';

export type BackButtonProps = Omit<ButtonProps, 'component' | 'to'> &
  ({ history: true; to?: never } | { history?: false; to: LinkProps['to'] });

export const BackButton: React.FC<React.PropsWithChildren<BackButtonProps>> = ({
  history,
  to,
  children = 'Back',
  ...props
}) => {
  const navigate = useNavigate();
  const buttonProps: ButtonProps = {
    variant: 'contained',
    color: 'primary',
    ...props,
    children,
  };

  return history ? (
    <Button {...buttonProps} onClick={() => navigate(-1)} />
  ) : (
    <RouterLinkButton {...buttonProps} to={to} />
  );
};
